import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list';

export function _createCalendar(calendarEl) {
  return function(events) {
    return function() {
      let calendar = new Calendar(calendarEl, {
        plugins: [dayGridPlugin, listPlugin, timeGridPlugin],
        initialView: 'listWeek',
        events: events,
        eventTimeFormat: { 
          hour: '2-digit',
          minute: '2-digit',
          hour12:false
        },
        eventDisplay: 'block',
        titleFormat: { year: 'numeric', month: 'long', day: 'numeric' },
        contentHeight: 'auto',
        headerToolbar: { 
          start: 'title',
          center: 'listWeek,dayGridMonth',
          end: 'today prev,next'

        }
      });
      calendar.render();
      //calendar.setOption('height', 500);
      return calendar;
    };
  };
}